import { getCountries, getCountryCallingCode } from 'libphonenumber-js';

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

/**
 * Full list of countries derived from libphonenumber-js metadata (245 entries).
 * Names come from the browser-native Intl.DisplayNames API.
 *
 * Shape: { iso: "IT", name: "Italy", code: "+39" }
 */
export const COUNTRIES = getCountries()
  .map((iso) => ({
    iso,
    name: regionNames.of(iso) ?? iso,
    code: `+${getCountryCallingCode(iso)}`,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

/**
 * Flat list of country names, sorted alphabetically.
 * Replaces the old hand-written COUNTRY_NAMES array.
 */
export const COUNTRY_NAMES = COUNTRIES.map((c) => c.name);
